export const DESCRIPTION_TITLES = {
	1: 'Evaluación',
	2: 'Competencias Requeridas para evaluar',
	3: 'Evaluación°',
};

export const QUESTION_TYPES = [
	{
		label: '1ra persona',
		key: 'firstPerson',
	},
	{
		label: '3ra persona',
		key: 'thirdPerson',
	},
];

export default {};



// WEBPACK FOOTER //
// ./src/modules/three-sixty-evaluation/constants/labels.constant.js